import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'vue-moment'

import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import VueInputCalculator from "vue-input-calculator";

Vue.component('vue-input-calculator', VueInputCalculator);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(moment);
Vue.use(Chartkick.use(Chart))

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import axios from 'axios'
import VueAxios from 'vue-axios'
 
Vue.use(VueAxios, axios)

axios.defaults.baseURL = 'https://appbono.fanosa.com/api';
Vue.config.productionTip = false ;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
